import { UserListResponse } from './commonResponse';
import { get } from './request';

const baseUrl = process.env.REACT_APP_COCALERO_API_URL + '/v2/web/auth';

export const AuthApi = {
    twitterAuth: (): Promise<string> =>
        get(baseUrl + '/login_twitter', false).then((res: { oauth_url: string }) => res.oauth_url),

    twitterAuthCallback: (token: string, verifier: string): Promise<void> => {
        const url = new URL(baseUrl + '/callback');
        const params = new URLSearchParams();
        params.append('oauth_token', token);
        params.append('oauth_verifier', verifier);
        url.search = params.toString();
        return get(url.toString()).then(() => Promise.resolve());
    },

    login: (): Promise<UserListResponse> => get(baseUrl + '/login').then((res: { user: UserListResponse }) => res.user),

    logout: (): Promise<void> => get(baseUrl + '/logout'),
};
